import { useState, useEffect } from 'react';

/**
 * A hook to detect if the software keyboard is likely open on mobile devices.
 * Uses focusin/focusout events on input/textarea/select elements.
 */
export function useKeyboardOpen() {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    let timeoutId;

    const handleFocusIn = (e) => {
      // Only track if on a smaller screen (mobile/tablet)
      if (window.innerWidth >= 1024) return;

      const tag = e.target?.tagName?.toLowerCase();
      if (tag === 'input' || tag === 'textarea' || tag === 'select') {
        // Exclude radio/checkbox/submit etc that don't trigger keyboards
        const type = e.target?.type?.toLowerCase();
        if (type !== 'radio' && type !== 'checkbox' && type !== 'submit' && type !== 'button' && type !== 'file') {
          clearTimeout(timeoutId);
          setIsKeyboardOpen(true);
        }
      }
    };

    const handleFocusOut = () => {
      if (window.innerWidth >= 1024) return;
      
      // Delay closing slightly to prevent flicker when jumping between inputs
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsKeyboardOpen(false);
      }, 100);
    };

    document.addEventListener('focusin', handleFocusIn);
    document.addEventListener('focusout', handleFocusOut);

    return () => {
      document.removeEventListener('focusin', handleFocusIn);
      document.removeEventListener('focusout', handleFocusOut);
      clearTimeout(timeoutId);
    };
  }, []);

  return isKeyboardOpen;
}
